/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { faFileAlt } from "@fortawesome/free-regular-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import MonthInput from "../../../components/InputWrapper/MonthInput"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"
import sogoYusoKaigiService from "../../../service/budget/sogoYusoKaigi/sogoYusoKaigiService"
import {
  TBudgetAchievementlistGetReq,
  TBudgetAchievementListGetRes,
  TSogoYusoKaigiPrintGetReq,
  T予算実績,
} from "../../../service/budget/sogoYusoKaigi/TSogoYusoKaigi"
import { 予算_実績メニューコード } from "../../../constant/menuCode"

import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import dayjs from "dayjs"
import { quotOrZero, decimalPlus } from "../../../ts/util/decimalUtil"
import { RootState } from "../../../globalStore/rootreducer"
import dateUtil from "../../../ts/util/dateUtil"
import {
  create総合輸送会議粗利益集計Data,
  粗利益列項目文字列,
} from "./sogoYusoKaigiConstant"

/**
 *　総合輸送会議
 * @returns
 */
const GrossProfitList = () => {
  const history = useHistory()
  const location = useLocation()
  const eigyobi = useSelector((state: RootState) => state.date.eigyobiStr)

  // ページエンター時のクエリを保持。AsyncAutoCompleteのdefaultValue用
  //   const firstQuery = queryString.parse(location.search)

  //TODO:ページ名称確定必須
  let gridId = "GrossProfitList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        年間金額str: (i: T予算実績) => cnvUriageStr(i.年間金額 ?? 0, i.項目),
        上期金額str: (i: T予算実績) => cnvUriageStr(i.上期金額 ?? 0, i.項目),
        下期金額str: (i: T予算実績) => cnvUriageStr(i.下期金額 ?? 0, i.項目),
        金額４月str: (i: T予算実績) => cnvUriageStr(i.金額４月, i.項目),
        金額５月str: (i: T予算実績) => cnvUriageStr(i.金額５月, i.項目),
        金額６月str: (i: T予算実績) => cnvUriageStr(i.金額６月, i.項目),
        金額７月str: (i: T予算実績) => cnvUriageStr(i.金額７月, i.項目),
        金額８月str: (i: T予算実績) => cnvUriageStr(i.金額８月, i.項目),
        金額９月str: (i: T予算実績) => cnvUriageStr(i.金額９月, i.項目),
        金額１０月str: (i: T予算実績) => cnvUriageStr(i.金額１０月, i.項目),
        金額１１月str: (i: T予算実績) => cnvUriageStr(i.金額１１月, i.項目),
        金額１２月str: (i: T予算実績) => cnvUriageStr(i.金額１２月, i.項目),
        金額１月str: (i: T予算実績) => cnvUriageStr(i.金額１月, i.項目),
        金額２月str: (i: T予算実績) => cnvUriageStr(i.金額２月, i.項目),
        金額３月str: (i: T予算実績) => cnvUriageStr(i.金額３月, i.項目),
      },
    })

  /**
   * 合計collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createSummaryCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      calculatedFields: {
        // 予算実績行の数値と達成率行のパーセンテージを表示するため文字列に変換
        年間金額str: (i: T予算実績) => cnvUriageStr(i.年間金額 ?? 0, i.項目),
        上期金額str: (i: T予算実績) => cnvUriageStr(i.上期金額 ?? 0, i.項目),
        下期金額str: (i: T予算実績) => cnvUriageStr(i.下期金額 ?? 0, i.項目),
        金額４月str: (i: T予算実績) => cnvUriageStr(i.金額４月, i.項目),
        金額５月str: (i: T予算実績) => cnvUriageStr(i.金額５月, i.項目),
        金額６月str: (i: T予算実績) => cnvUriageStr(i.金額６月, i.項目),
        金額７月str: (i: T予算実績) => cnvUriageStr(i.金額７月, i.項目),
        金額８月str: (i: T予算実績) => cnvUriageStr(i.金額８月, i.項目),
        金額９月str: (i: T予算実績) => cnvUriageStr(i.金額９月, i.項目),
        金額１０月str: (i: T予算実績) => cnvUriageStr(i.金額１０月, i.項目),
        金額１１月str: (i: T予算実績) => cnvUriageStr(i.金額１１月, i.項目),
        金額１２月str: (i: T予算実績) => cnvUriageStr(i.金額１２月, i.項目),
        金額１月str: (i: T予算実績) => cnvUriageStr(i.金額１月, i.項目),
        金額２月str: (i: T予算実績) => cnvUriageStr(i.金額２月, i.項目),
        金額３月str: (i: T予算実績) => cnvUriageStr(i.金額３月, i.項目),
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: TBudgetAchievementlistGetReq) => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: TBudgetAchievementlistGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const cond = currentSearchCondition
      cond.年 = dayjs(currentSearchCondition.年月).year()
      cond.月 = dayjs(currentSearchCondition.年月).month() + 1

      const res = await new sogoYusoKaigiService().getGrossProfitList(cond)
      const resData: T予算実績[] = []
      // 週ごとのフィールドを作成して格納する
      res.data.forEach((d: TBudgetAchievementListGetRes) => {
        let 月 = (dayjs(d.年月 + "/01").month() + 1).toString()
        let rowData: T予算実績 = {
          年月: "",
          部所コード: "",
          部所名: "",
          項目: "",
          金額１月: 0,
          金額２月: 0,
          金額３月: 0,
          金額４月: 0,
          金額５月: 0,
          金額６月: 0,
          金額７月: 0,
          金額８月: 0,
          金額９月: 0,
          金額１０月: 0,
          金額１１月: 0,
          金額１２月: 0,
          年間金額: 0,
          上期金額: 0,
          下期金額: 0,
        }
        rowData.部所名 = d.部所名
        rowData.部所コード = d.部所コード
        rowData.項目 = d.項目
        rowData.年月 = d.年月
        switch (月) {
          case "4":
            rowData.金額４月 = d.金額
            resData.push(rowData)
            break
          case "5":
            rowData.金額５月 = d.金額
            resData.push(rowData)
            break
          case "6":
            rowData.金額６月 = d.金額
            resData.push(rowData)
            break
          case "7":
            rowData.金額７月 = d.金額
            resData.push(rowData)
            break
          case "8":
            rowData.金額８月 = d.金額
            resData.push(rowData)
            break
          case "9":
            rowData.金額９月 = d.金額
            resData.push(rowData)
            break
          case "10":
            rowData.金額１０月 = d.金額
            resData.push(rowData)
            break
          case "11":
            rowData.金額１１月 = d.金額
            resData.push(rowData)
            break
          case "12":
            rowData.金額１２月 = d.金額
            resData.push(rowData)
            break
          case "1":
            rowData.金額１月 = d.金額
            resData.push(rowData)
            break
          case "2":
            rowData.金額２月 = d.金額
            resData.push(rowData)
            break
          case "3":
            rowData.金額３月 = d.金額
            resData.push(rowData)
            break
          default:
            break
        }
      })
      // 部所・項目でGROUP BY的な処理
      const d = resData.reduce((result: T予算実績[], current) => {
        const element = result.find(
          (r) => r.部所名 === current.部所名 && r.項目 === current.項目
        )
        if (element) {
          let 上期金額 = decimalPlus([
            element.上期金額 ?? 0,
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          let 下期金額 = decimalPlus([
            element.下期金額 ?? 0,
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          element.上期金額 = 上期金額
          element.下期金額 = 下期金額
          element.年間金額 = decimalPlus([上期金額, 下期金額])
          element.金額４月 = decimalPlus([element.金額４月, current.金額４月])
          element.金額５月 = decimalPlus([element.金額５月, current.金額５月])
          element.金額６月 = decimalPlus([element.金額６月, current.金額６月])
          element.金額７月 = decimalPlus([element.金額７月, current.金額７月])
          element.金額８月 = decimalPlus([element.金額８月, current.金額８月])
          element.金額９月 = decimalPlus([element.金額９月, current.金額９月])
          element.金額１０月 = decimalPlus([
            element.金額１０月,
            current.金額１０月,
          ])
          element.金額１１月 = decimalPlus([
            element.金額１１月,
            current.金額１１月,
          ])
          element.金額１２月 = decimalPlus([
            element.金額１２月,
            current.金額１２月,
          ])
          element.金額１月 = decimalPlus([element.金額１月, current.金額１月])
          element.金額２月 = decimalPlus([element.金額２月, current.金額２月])
          element.金額３月 = decimalPlus([element.金額３月, current.金額３月])
        } else {
          current.上期金額 = decimalPlus([
            current.金額４月,
            current.金額５月,
            current.金額６月,
            current.金額７月,
            current.金額８月,
            current.金額９月,
          ])
          current.下期金額 = decimalPlus([
            current.金額１０月,
            current.金額１１月,
            current.金額１２月,
            current.金額１月,
            current.金額２月,
            current.金額３月,
          ])
          current.年間金額 = decimalPlus([current.上期金額, current.下期金額])
          result.push(current)
        }
        return result
      }, [])

      // 粗利益を作成
      const arariekiData = d.reduce((result: T予算実績[], current) => {
        const uriage = result.find(
          (r) => r.部所名 === current.部所名 && r.項目 === "売上"
        )
        if (
          uriage &&
          uriage.部所名 === current.部所名 &&
          current.項目 === "変動費"
        ) {
          result.push(current)
          const tassei: T予算実績 = {
            年月: uriage.年月,
            部所名: uriage.部所名,
            部所コード: uriage.部所コード,
            項目: "粗利益",
            年間金額: decimalPlus([
              -(current.年間金額 ?? 0),
              uriage.年間金額 ?? 0,
            ]),
            上期金額: decimalPlus([
              -(current.上期金額 ?? 0),
              uriage.上期金額 ?? 0,
            ]),
            下期金額: decimalPlus([
              -(current.下期金額 ?? 0),
              uriage.下期金額 ?? 0,
            ]),
            金額４月: decimalPlus([-current.金額４月, uriage.金額４月]),
            金額５月: decimalPlus([-current.金額５月, uriage.金額５月]),
            金額６月: decimalPlus([-current.金額６月, uriage.金額６月]),
            金額７月: decimalPlus([-current.金額７月, uriage.金額７月]),
            金額８月: decimalPlus([-current.金額８月, uriage.金額８月]),
            金額９月: decimalPlus([-current.金額９月, uriage.金額９月]),
            金額１０月: decimalPlus([-current.金額１０月, uriage.金額１０月]),
            金額１１月: decimalPlus([-current.金額１１月, uriage.金額１１月]),
            金額１２月: decimalPlus([-current.金額１２月, uriage.金額１２月]),
            金額１月: decimalPlus([-current.金額１月, uriage.金額１月]),
            金額２月: decimalPlus([-current.金額２月, uriage.金額２月]),
            金額３月: decimalPlus([-current.金額３月, uriage.金額３月]),
            報告テキスト１: uriage.報告テキスト１,
            報告テキスト２: uriage.報告テキスト２,
            報告テキスト３: uriage.報告テキスト３,
            報告テキスト４: uriage.報告テキスト４,
            報告テキスト５: uriage.報告テキスト５,
          }
          result.push(tassei)
        } else {
          result.push(current)
        }
        return result
      }, [])

      // 達成率を作成
      const gridRowData = arariekiData.reduce(
        (result: T予算実績[], current) => {
          const yosan = result.find(
            (r) => r.部所名 === current.部所名 && r.項目 === "売上"
          )
          if (
            yosan &&
            yosan.部所名 === current.部所名 &&
            current.項目 === "粗利益"
          ) {
            result.push(current)
            const tassei: T予算実績 = {
              年月: yosan.年月,
              部所名: yosan.部所名,
              部所コード: yosan.部所コード,
              項目: "利益率",
              年間金額: quotOrZero(current.年間金額 ?? 0, yosan.年間金額 ?? 0),
              上期金額: quotOrZero(current.上期金額 ?? 0, yosan.上期金額 ?? 0),
              下期金額: quotOrZero(current.下期金額 ?? 0, yosan.下期金額 ?? 0),
              金額４月: quotOrZero(current.金額４月, yosan.金額４月),
              金額５月: quotOrZero(current.金額５月, yosan.金額５月),
              金額６月: quotOrZero(current.金額６月, yosan.金額６月),
              金額７月: quotOrZero(current.金額７月, yosan.金額７月),
              金額８月: quotOrZero(current.金額８月, yosan.金額８月),
              金額９月: quotOrZero(current.金額９月, yosan.金額９月),
              金額１０月: quotOrZero(current.金額１０月, yosan.金額１０月),
              金額１１月: quotOrZero(current.金額１１月, yosan.金額１１月),
              金額１２月: quotOrZero(current.金額１２月, yosan.金額１２月),
              金額１月: quotOrZero(current.金額１月, yosan.金額１月),
              金額２月: quotOrZero(current.金額２月, yosan.金額２月),
              金額３月: quotOrZero(current.金額３月, yosan.金額３月),
              報告テキスト１: yosan.報告テキスト１,
              報告テキスト２: yosan.報告テキスト２,
              報告テキスト３: yosan.報告テキスト３,
              報告テキスト４: yosan.報告テキスト４,
              報告テキスト５: yosan.報告テキスト５,
            }
            result.push(tassei)
          } else {
            result.push(current)
          }
          return result
        },
        []
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(gridRowData, pageSize) })

      // 合計グリッドの作成
      const summaryData: T予算実績[] = []
      summaryData.push(
        create総合輸送会議粗利益集計Data(gridRowData, 粗利益列項目文字列.売上)
      )
      summaryData.push(
        create総合輸送会議粗利益集計Data(gridRowData, 粗利益列項目文字列.変動費)
      )
      summaryData.push(
        create総合輸送会議粗利益集計Data(gridRowData, 粗利益列項目文字列.粗利益)
      )

      summaryData.push({
        年月: "",
        部所コード: "",
        部所名: "全社",
        項目: "利益率",
        年間金額: quotOrZero(
          summaryData[2].年間金額!,
          summaryData[0].年間金額!
        ),
        上期金額: quotOrZero(
          summaryData[2].上期金額!,
          summaryData[0].上期金額!
        ),
        下期金額: quotOrZero(
          summaryData[2].下期金額!,
          summaryData[0].下期金額!
        ),
        金額４月: quotOrZero(summaryData[2].金額４月, summaryData[0].金額４月),
        金額５月: quotOrZero(summaryData[2].金額５月, summaryData[0].金額５月),
        金額６月: quotOrZero(summaryData[2].金額６月, summaryData[0].金額６月),
        金額７月: quotOrZero(summaryData[2].金額７月, summaryData[0].金額７月),
        金額８月: quotOrZero(summaryData[2].金額８月, summaryData[0].金額８月),
        金額９月: quotOrZero(summaryData[2].金額９月, summaryData[0].金額９月),
        金額１０月: quotOrZero(
          summaryData[2].金額１０月,
          summaryData[0].金額１０月
        ),
        金額１１月: quotOrZero(
          summaryData[2].金額１１月,
          summaryData[0].金額１１月
        ),
        金額１２月: quotOrZero(
          summaryData[2].金額１２月,
          summaryData[0].金額１２月
        ),
        金額１月: quotOrZero(summaryData[2].金額１月, summaryData[0].金額１月),
        金額２月: quotOrZero(summaryData[2].金額２月, summaryData[0].金額２月),
        金額３月: quotOrZero(summaryData[2].金額３月, summaryData[0].金額３月),
        報告テキスト１: "",
        報告テキスト２: "",
        報告テキスト３: "",
        報告テキスト４: "",
        報告テキスト５: "",
      })

      setSummaryGridData({
        data: createSummaryCollectionView(summaryData, pageSize),
      })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query: TBudgetAchievementlistGetReq = queryString.parse(
      location.search
    )
    set年月(query.年月)
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): TBudgetAchievementlistGetReq => {
    return {
      年月: 年月 ?? undefined,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: TBudgetAchievementlistGetReq
  ) => {
    return {
      年月: dateUtil.format(searchCondition.年月, "YYYY/MM") ?? "",
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年月("")
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    grid.formatItem.addHandler(formatItem)

    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {}

  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "部所名",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = [
        "部所名",
        "報告テキスト１",
        "報告テキスト２",
        "報告テキスト３",
        "報告テキスト４",
        "報告テキスト５",
      ]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  // 便利な関数たち
  /**
   * gridの行フォーマット作成用
   * @param i 数値
   * @param 項目 予算／実績／達成率
   * @return string
   */
  const cnvUriageStr = (i: number, 項目: string) => {
    if (項目 === "利益率") {
      return new Intl.NumberFormat("ja", {
        style: "percent",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(i)
    } else {
      return new Intl.NumberFormat().format(i)
    }
  }

  /**
   * 予算実績帳票印刷処理
   */
  const printArariekiReport = async () => {
    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に
    let currentSearchCondition = createSearchCondition()
    let 年 = dayjs(currentSearchCondition.年月).year()
    let 月 = dayjs(currentSearchCondition.年月).month() + 1

    const printCondition: TSogoYusoKaigiPrintGetReq = {
      抽出条件_年: 年,
      抽出条件_月: 月,
    }
    try {
      const res = await new sogoYusoKaigiService({
        responseType: "blob",
      }).printArariekiReport(printCondition)

      var fileURL = URL.createObjectURL(res)
      window.open(fileURL)
      setTimeout(() => {
        URL.revokeObjectURL(fileURL)
      }, 500)
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // サマリ用グリッド
  const [summaryFlexGrid, setSummaryFlexGrid] = useState<wjGrid.FlexGrid>()
  const [summaryGridData, setSummaryGridData] = useState<{
    data: wjCore.CollectionView
  }>({
    data: createSummaryCollectionView([], 1),
  })

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]
  const [年月, set年月] = useState<string | null>()

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    set年月(eigyobi)
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `輸送戦略会議　粗利益一覧`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">輸送戦略会議</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="w-35rem">
            <Card.Body>
              <div>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_予算実績
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={isSearching}>予算実績</Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_粗利益一覧
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={true}>
                    粗利益一覧
                  </Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_荷主売上一覧
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button disabled={isSearching}>荷主売上一覧</Button>
                </Link>
                <Link
                  to={
                    util.getMenuPath(
                      予算_実績メニューコード.総合輸送会議_部所予算実績
                    )[0]
                  }
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-2" disabled={isSearching}>
                    部所予算実績
                  </Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-35rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <MonthInput
                                id="年月"
                                placeholder="年月"
                                value={年月}
                                setValue={set年月}></MonthInput>
                            </div>
                          </div>
                        </div>
                      </Col>
                      <Col className="text-end">
                        <Button
                          type="submit"
                          disabled={isSearching}
                          onClick={(e) => {
                            e.stopPropagation()
                            e.preventDefault()
                            search()
                          }}>
                          <FontAwesomeIcon icon={faSearch} />
                          検索
                        </Button>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 合計カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <FlexGridOuter
                flexGrid={summaryFlexGrid}
                gridConstantProperties={
                  CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS_TOTAL
                }
                setFlexGrid={setSummaryFlexGrid}
                gridData={summaryGridData}
                setGridData={setSummaryGridData}
                pageNumber={pageNumber}
                gridId={`${gridId}_1`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                isShowGridFooter={false}
                isShowGridHeader={false}
                hasFilter={false}
                gridProperties={{
                  mergeManager: new RestrictedMergeManager(),
                  frozenColumns: 2,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={192}
                  cssClass="dummy-header-cell"
                  header="合計"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="項目"
                  width={64}
                  cssClass="dummy-header-cell"
                  header="項目"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年間金額str"
                  width={110}
                  cssClass="number-col"
                  header="年間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額４月str"
                  width={110}
                  cssClass="number-col"
                  header="４月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額５月str"
                  width={110}
                  cssClass="number-col"
                  header="５月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額６月str"
                  width={110}
                  cssClass="number-col"
                  header="６月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額７月str"
                  width={110}
                  cssClass="number-col"
                  header="７月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額８月str"
                  width={110}
                  cssClass="number-col"
                  header="８月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額９月str"
                  width={110}
                  cssClass="number-col"
                  header="９月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="上期金額str"
                  width={110}
                  cssClass="number-col"
                  header="上期"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１０月str"
                  width={110}
                  cssClass="number-col"
                  header="１０月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１１月str"
                  width={110}
                  cssClass="number-col"
                  header="１１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１２月str"
                  width={110}
                  cssClass="number-col"
                  header="１２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１月str"
                  width={110}
                  cssClass="number-col"
                  header="１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額２月str"
                  width={110}
                  cssClass="number-col"
                  header="２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額３月str"
                  width={110}
                  cssClass="number-col"
                  header="３月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="下期金額str"
                  width={110}
                  cssClass="number-col"
                  header="下期"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}_2`}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                gridInitializedHandler={gridInitializedHandler}
                changePageSizeTargetNumberArray={[16, 32, 48, 64, 0]}
                gridProperties={{
                  mergeManager: new RestrictedMergeManager(),
                  frozenColumns: 2,
                }}
                headerComponent={
                  <div>
                    <Button
                      disabled={isSearching}
                      className="btn-done"
                      onClick={(e: any) => {
                        e.stopPropagation()
                        e.preventDefault()
                        printArariekiReport()
                      }}>
                      <FontAwesomeIcon icon={faFileAlt} />
                      粗利益一覧印刷
                    </Button>
                  </div>
                }>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={192}
                  allowDragging={false}
                  cssClass="dummy-header-cell"
                  header="部所名"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="項目"
                  width={64}
                  allowDragging={false}
                  cssClass="dummy-header-cell"
                  header="項目"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="年間金額str"
                  width={105}
                  cssClass="number-col"
                  header="年間"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額４月str"
                  width={100}
                  cssClass="number-col"
                  header="４月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額５月str"
                  width={100}
                  cssClass="number-col"
                  header="５月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額６月str"
                  width={100}
                  cssClass="number-col"
                  header="６月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額７月str"
                  width={100}
                  cssClass="number-col"
                  header="７月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額８月str"
                  width={100}
                  cssClass="number-col"
                  header="８月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額９月str"
                  width={100}
                  cssClass="number-col"
                  header="９月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="上期金額str"
                  width={105}
                  cssClass="number-col"
                  header="上期"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１０月str"
                  width={100}
                  cssClass="number-col"
                  header="１０月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１１月str"
                  width={100}
                  cssClass="number-col"
                  header="１１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１２月str"
                  width={100}
                  cssClass="number-col"
                  header="１２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額１月str"
                  width={100}
                  cssClass="number-col"
                  header="１月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額２月str"
                  width={100}
                  cssClass="number-col"
                  header="２月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="金額３月str"
                  width={100}
                  cssClass="number-col"
                  header="３月"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="下期金額str"
                  width={105}
                  cssClass="number-col"
                  header="下期"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default GrossProfitList
